import { createContext } from 'react';

export const DrawersMultimediaContext = createContext({
  isOpenImagesDrawer: false,
  setIsOpenImagesDrawerAction: (isOpen: boolean) => {},
  isOpenVideosDrawer: false,
  setIsOpenVideosDrawerAction: (isOpen: boolean) => {},
});
